/** The API's branding view, as the strings and arrays the inputs hold. */
export function toFormValues(branding) {
  return {
    tagline: branding?.tagline ?? '',
    accent_color: branding?.accent_color ?? '',
    mission: branding?.mission ?? '',
    culture: branding?.culture ?? '',
    values: (branding?.values ?? []).map((value) => ({
      title: value.title ?? '',
      description: value.description ?? '',
    })),
    perks: (branding?.perks ?? []).map((perk) => perk.code),
    video_url: branding?.video?.url ?? '',
  };
}
